export default "__VITE_ASSET__DG498jeQ__"